import React, { useState, useEffect } from 'react';
import {
    StyleSheet,
    Text,
    View,
    TextInput,
    TouchableOpacity,
} from 'react-native';
import Data from './Data';
import { getStorage } from '../storage';

export default function ChangePW({ navigation }: any) {
    const [currentPW, setCurrentPW] = useState('');
    const [pw, setPW] = useState('');
    const [checkPW, setChackPW] = useState('');
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const checkpw = /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z!@#$%^&*()]{6,10}$/;
        setChecked(checkpw.test(pw));
    }, [pw]);

    const onChangePW = (text: any) => setPW(text);
    const onChangeChecked = (text: any) => setChackPW(text);

    const setChange = () => {
        if (!currentPW) {
            alert('현재 비밀번호를 입력해주세요.');
            return;
        }
        if (pw && checkPW) {
            if (pw === checkPW) {
                if (checked) {
                    const updatePW = async () => {
                    // 로그인한 계정 ID는 Session 에 들어있다.
                    // 예전엔 AutoLogin 을 읽었는데, 자동로그인을 체크하지 않으면
                    // Login.tsx 가 id 를 빈 문자열('')로 저장한다. ?? 는 null/undefined 만
                    // 걸러내므로 ''가 그대로 전송되어 WHERE ID='' → 0건 → 무반응이었다.
                    const session = await getStorage('Session');
                    const autoLogin = await getStorage('AutoLogin');
                    const userId = session?.id || autoLogin?.id || '';

                    if (!userId) {
                        alert('로그인 정보를 찾을 수 없습니다. 다시 로그인한 뒤 시도해 주세요.');
                        return;
                    }

                    Data.fetchData('user/updateUserPassword', {
                        ID: userId,
                        CURRENT_PASSWORD: currentPW,   // 서버가 현재 비밀번호를 확인한다
                        PASSWORD: pw
                    }, (result: any, count: any) => {
                        if (count === 1) {
                            alert('비밀번호가 변경되었습니다.');
                            navigation.goBack();
                        } else if (count === -3) {
                            alert('현재 비밀번호가 일치하지 않습니다.');
                        } else {
                            // 예전엔 여기가 비어 있어서 실패해도 아무 반응이 없었다.
                            alert('비밀번호 변경에 실패했습니다. 다시 로그인한 뒤 시도해 주세요.');
                        }
                    }, true);
                    };
                    updatePW();
                } else {
                    alert('비밀번호는 영문과 숫자를 반드시 포함한 6-10자입니다.\n특수문자는 ! @ # $ % ^ & * ( ) 만 사용할 수 있습니다.')
                }
            } else {
                alert('비밀번호를 동일하게 입력해주세요');
            }
        } else {
            alert('비밀번호를 입력해주세요.');
        }
    };


    return (
        <View style={styles.container}>
            <View style={styles.rowStyle}>
                <Text style={styles.title}>현재 비밀번호</Text>
                <TextInput autoCapitalize='none' clearButtonMode='always' placeholder={'현재 사용 중인 비밀번호를 입력하세요.'}
                    style={styles.textInputBox} secureTextEntry={true} onChangeText={(text) => setCurrentPW(text)} value={currentPW} />
            </View>
            <View style={styles.rowStyle}>
                <Text style={styles.title}>새로운 비밀번호</Text>
                <TextInput autoCapitalize='none' clearButtonMode='always' placeholder={'영문+숫자 포함 6-10자 (특수문자는 !@#$%^&*() 만)'}
                    style={styles.textInputBox} secureTextEntry={true} onChangeText={(text) => onChangePW(text)} value={pw} />
            </View>
            <View style={[styles.rowStyle]}>
                <Text style={styles.title}>비밀번호 확인</Text>
                <View style={{ width: '60%' }}>
                    <TextInput autoCapitalize='none' clearButtonMode='always' placeholder={'비밀번호를 확인하세요.'} secureTextEntry={true}
                        style={[styles.textInputBox, { width: '100%' }]} onChangeText={(text) => onChangeChecked(text)} value={checkPW} />
                    {pw !== checkPW ?
                        <Text style={{ fontSize: 13, color: 'red', marginTop: 2, marginLeft: 3 }}>비밀번호를 동일하게 입력해주세요.</Text>
                        : null}
                </View>
            </View>
            <TouchableOpacity style={styles.buttonBox} onPress={() => { setChange() }}>
                <Text style={{ fontSize: 18, color: '#fff', fontWeight: '600' }}>변경하기</Text>
            </TouchableOpacity>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ECF1F4',
    },
    title: {
        fontSize: 20,
        color: '#304156',
        fontWeight: '600'
    },
    rowStyle: {
        width: '45%',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 20,
        justifyContent: 'space-around'
    },
    textInputBox: {
        width: '60%',
        height: 50,
        borderWidth: 1,
        borderColor: '#fff',
        borderRadius: 10,
        paddingHorizontal: 13,
        backgroundColor: '#fff',
    },
    buttonBox: {
        width: '40%',
        height: 50,
        backgroundColor: '#42B983',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
        marginTop: 30
    }

});